export function xmlToJson(xml) {
  const json = {};
  const regExp = /(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm;

  if (xml) {
    for (const res of xml.matchAll(regExp)) {
      const key = res[1] || res[3];
      const value = res[2] && xmlToJson(res[2]);
      json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;
    }
  }

  return json;
}
